<template>
  <v-select
    :label="label"
    :outlined="outlined"
    :items="items"
    item-text="name"
    item-value="name"
    v-model="selectedLeadSource"
    @change="onChange"
    :clearable="clearable"
  ></v-select>
</template>

<script>
import { removeGQLTypename } from "../../../helpers";
import { LEAD_SOURCES_QUERY } from "../../../constants/graphql";

const sortLeadSourcesByName = (leadSourceA, leadSourceB) => {
  return leadSourceA.name > leadSourceB.name ? 1 : -1;
};

export default {
  name: "lead-source-list-select",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
    label: {
      type: String,
      default: () => "Lead Source",
    },
  },

  data() {
    return {
      debug: false,
      selectedLeadSource: this.value ? this.value : "",
    };
  },

  computed: {
    items() {
      return this.leadSources && this.leadSources.edges
        ? this.leadSources.edges
            .map(removeGQLTypename)
            .sort(sortLeadSourcesByName)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.selectedLeadSource = newVal;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.selectedLeadSource);
    },
  },

  apollo: {
    leadSources: {
      query: LEAD_SOURCES_QUERY,
      variables() {
        return {
          filter: {},
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/LeadSourceListSelect.vue